<!--
@Time : 2020/12/1 2:51 下午
@Author : yekong
@File : haoshileixing.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="hslx">
      <div class="haoshibt">
        <div class="item">耗时类型</div>
        <div class="item">个人所得税</div>
        <div class="item">增值税</div>
        <div class="item">企业所得税</div>
        <div class="item">社保费</div>
        <div class="item">公积金</div>
      </div>
      <div class="haoshibody">
        <div class="item2">
          准备时间
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
      </div>
      <div class="haoshibody">
        <div class="item2 bg2">
          申报时间
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
      </div>
      <div class="haoshibody">
        <div class="item2">
          缴纳时间
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
        <div class="item2 bg2">
          <zhuzhuangtu></zhuzhuangtu>
        </div>
      </div>
      <div class="haoshibody2">
        <div class="bj">
          <span></span>
          北京
        </div>
        <div class="bj">
          <span class="bg3"></span>
          大连
        </div>
        <div class="bj">
          <span class="bg4"></span>
          上海
        </div>
        <div class="bj">
          <span class="bg5"></span>
          深圳
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import zhuzhuangtu from "@/components/nashui/zhuzhuangtu";

export default {
  name: "haoshileixing",
  components: {zhuzhuangtu},
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.haoshibt {
  width: 944px;
  height: 48px;
  background: #404C6E;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-top: 28px;

  .item {
    font-size: 28px;
    font-family: PingFang;
    font-weight: 800;
    color: #FFFFFF;
    width: 16.66%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }
}

.haoshibody {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;

  .item2 {
    width: 160px;
    height: 109px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}

.bg2 {
  background: rgba(64, 76, 110, 0.2);
}

.haoshibody2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  margin-top: 30px;

  .bj {
    margin-right: 15px;
    margin-left: 15px;

    span {
      width: 25px;
      height: 16px;
      background: #4FC7EA;
      display: inline-block;
    }
  }
}

.bg3 {
  background: rgba(255, 126, 75, 1) !important;
}

.bg4 {
  background: rgba(136, 43, 205, 1) !important;
}

.bg5 {
  background: rgba(60, 175, 133, 1) !important;
}
</style>
